"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChowlyWebhookUniversalMetaToJSON = exports.ChowlyWebhookUniversalMetaFromJSONTyped = exports.ChowlyWebhookUniversalMetaFromJSON = void 0;
function ChowlyWebhookUniversalMetaFromJSON(json) {
    return ChowlyWebhookUniversalMetaFromJSONTyped(json, false);
}
exports.ChowlyWebhookUniversalMetaFromJSON = ChowlyWebhookUniversalMetaFromJSON;
function ChowlyWebhookUniversalMetaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': json['version'],
    };
}
exports.ChowlyWebhookUniversalMetaFromJSONTyped = ChowlyWebhookUniversalMetaFromJSONTyped;
function ChowlyWebhookUniversalMetaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
    };
}
exports.ChowlyWebhookUniversalMetaToJSON = ChowlyWebhookUniversalMetaToJSON;
